module.exports = __webpack_public_path__ + "static/media/media-4.ba1197d8.jpg";